/**
 * MobileBottomNav.jsx — Rê Leve
 * Bottom nav nativo para PWA / mobile (≤768px). Esconde no desktop.
 * 4 abas: Home · Cardápio · Carrinho · Saúde
 */

import { useEffect, useState } from 'react';

const TABS = [
  { id: 'home',     icon: '🏠', label: 'Início',   action: 'scroll-top' },
  { id: 'cardapio', icon: '🥗', label: 'Cardápio', action: 'scroll-kits' },
  { id: 'cart',     icon: '🛒', label: 'Carrinho', action: 'scroll-checkout' },
  { id: 'saude',    icon: '📊', label: 'Saúde',    action: 'scroll-calorias' },
];

export default function MobileBottomNav() {
  const [active, setActive] = useState('home');

  // Atualizar aba ativa ao scrollar
  useEffect(() => {
    function onScroll() {
      if (typeof window === 'undefined') return;
      const y = window.scrollY + window.innerHeight / 3;

      const kits = document.querySelector('.cs-kits-grid');
      const checkout = document.querySelector('.cs-checkout-card');
      const calorico = document.querySelector('.cs-calorico-card, [class*="CalorieTracker"]');
      const cta = document.querySelector('.cs-cta-section');

      if (calorico && y > calorico.offsetTop) {
        setActive('saude');
      } else if (checkout && y > checkout.offsetTop) {
        setActive('cart');
      } else if (cta && y > cta.offsetTop) {
        setActive('saude');
      } else if (kits && y > kits.offsetTop) {
        setActive('cardapio');
      } else {
        setActive('home');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  function handleClick(tab) {
    setActive(tab.id);
    if (typeof window === 'undefined') return;

    if (tab.action === 'scroll-top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    if (tab.action === 'scroll-kits') {
      const el = document.querySelector('.cs-kits-grid');
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (tab.action === 'scroll-checkout') {
      const el = document.querySelector('.cs-checkout-card, .cs-chat');
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (tab.action === 'scroll-calorias') {
      const el = document.querySelector('[class*="CalorieTracker"], .cs-calorico-card');
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
  }

  return (
    <nav className="rl-bottom-nav" aria-label="Navegação principal">
      {TABS.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => handleClick(t)}
          aria-current={active === t.id ? 'page' : undefined}
          className={'rl-bottom-nav__item' + (active === t.id ? ' rl-bottom-nav__item--active' : '')}
        >
          <span className="rl-nav-icon" aria-hidden="true">{t.icon}</span>
          <span>{t.label}</span>
        </button>
      ))}
    </nav>
  );
}
